<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<ng-container *ngIf="!showPreLogin">
    <div id="main-wrapper">
        <ng-container *ngIf="showLandingPage">
            <app-landing></app-landing>
        </ng-container>

        <ng-container *ngIf="!showLandingPage">
            <!-- ============================================================== -->
            <!-- Left Sidebar - style you can find in sidebar.scss  -->
            <!-- ============================================================== -->
            <aside *ngIf="false" class="left-sidebar hide-print">
                <!-- Sidebar scroll-->
                <div class="scroll-sidebar"> <!-- [perfectScrollbar]="config" -->
                    <!-- <app-sidebar [isSinglePage]="true"></app-sidebar> -->
                </div>
                <!-- End Sidebar scroll-->
            </aside>
            <!-- ============================================================== -->
            <!-- End Left Sidebar - style you can find in sidebar.scss  -->
            <!-- ============================================================== -->

            <!-- ============================================================== -->
            <!-- Page wrapper  -->
            <!-- ============================================================== -->
            <div class="bg-white" style="min-height: 100vh;">
                <app-breadcrumb></app-breadcrumb>
                <!-- ============================================================== -->
                <!-- Container fluid  -->
                <!-- ============================================================== -->
                <router-outlet></router-outlet>
                <!-- ============================================================== -->
                <!-- End Container fluid  -->
                <!-- ============================================================== -->
            </div>
            <!-- ============================================================== -->
            <!-- End Page wrapper  -->
            <!-- ============================================================== -->
            <!-- <app-footer [isSinglePage]="true" [isDesktop]="isDesktop"></app-footer> -->
        </ng-container>
    </div>
</ng-container>

<ng-template #updateAvailable let-modal>
    <div class="p-20">
        <div class="container" style="width: 320px;">
            <div class=" text-center">
                <img class="logo-invitation" src="assets/images/icon_down.png" alt="Logo">
                <div class="title">¡Hay una nueva versión de Givi disponible!</div>

                <div>
                    <div>
                        <div class="subtitle">¡Instálala ahora!</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group text-center m-t-20">
            <a href="https://holagivi.com/apps/" target="_blank" rel="noopener" class="btn btn-dark btn-wmd">
                    Actualizar
                </a>
        </div>
    </div>
</ng-template>


<ng-container *ngIf="showPreLogin">
    <!-- <div class=" d-flex-center pre-login">
        <img class="img-responsive" src="assets/images/givi-pre-login.gif">
    </div> -->
</ng-container>